var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.dataProvider && _vm.dataProvider.height)?_c('v-flex',{style:({height: _vm.dataProvider.height ? _vm.dataProvider.height : '50px'}),attrs:{"xs12":""}}):_c('fx-anomalie-composant',{attrs:{"composant":"fx-space","propriete":"height"}})
}
var staticRenderFns = []

export { render, staticRenderFns }